import { SidebarMenuType } from "../../Types/Layout.type";
import { decryptData } from "../../Tools/Cipher/EncryptData";
let menuList: SidebarMenuType[] = [
  {
    title: "- General",
    apps: "general",
    menu: [
      {
        id: 1,
        title: "Dashboard",
        icon: "home",
        badge: true,
        badgeName: "3",
        badgeColor: "light-primary",
        type: "sub",
        active: false,
        resource: "admin",
        menu: [
          {
            title: "Default",
            type: "link",
            url: `${process.env.PUBLIC_URL}/dashboard/default`,
          },
          {
            title: "Ecommerce",
            type: "link",
            url: `${process.env.PUBLIC_URL}/dashboard/ecommerce`,
          },
          {
            title: "Project",
            type: "link",
            url: `${process.env.PUBLIC_URL}/dashboard/project`,
          },
        ],
      },
      {
        id: 2,
        title: "Widgets",
        icon: "widget",
        type: "sub",
        active: false,

        menu: [
          {
            title: "General",
            type: "link",
            url: `${process.env.PUBLIC_URL}/widgets/general_widget`,
          },
          {
            title: "Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/widgets/chart_widget`,
          },
        ],
      },
    ],
  },
  {
    title: "- Applications",
    menu: [
      {
        id: 3,
        title: "Project",
        type: "sub",
        icon: "project",
        badge: true,
        badgeName: "New",
        badgeColor: "light-secondary",
        active: false,
        menu: [
          {
            title: "Project List",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/project/project_list`,
          },
          {
            title: "Project Create",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/project/create_project`,
          },
        ],
      },
      {
        id: 4,
        title: "File Manager",
        url: `${process.env.PUBLIC_URL}/applications/file_manager`,
        icon: "file",
        type: "link",
      },
      {
        id: 5,
        title: "Ecommerce",
        icon: "ecommerce",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Add Products",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/add_products`,
          },
          {
            title: "Product",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/product`,
          },
          {
            title: "Category Page",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/category_page`,
          },
          {
            title: "Product Page",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/product_page`,
          },
          {
            title: "Product list",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/product_list`,
          },
          {
            title: "Payment Details",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/payment_details`,
          },
          {
            title: "Order History",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/order_history`,
          },
          {
            title: "Invoices",
            type: "sub",
            menu: [
              {
                title: "Invoice-1",
                type: "link",
                url: `${process.env.PUBLIC_URL}/invoice/invoice_1`,
              },
              {
                title: "Invoice-2",
                type: "link",
                url: `${process.env.PUBLIC_URL}/invoice/invoice_2`,
              },
              {
                title: "Invoice-3",
                type: "link",
                url: `${process.env.PUBLIC_URL}/invoice/invoice_3`,
              },
              {
                title: "Invoice-4",
                type: "link",
                url: `${process.env.PUBLIC_URL}/invoice/invoice_4`,
              },
              {
                title: "Invoice-5",
                type: "link",
                url: `${process.env.PUBLIC_URL}/invoice/invoice_5`,
              },
              {
                title: "Invoice-6",
                type: "link",
                url: `${process.env.PUBLIC_URL}/invoice/invoice_6`,
              },
            ],
          },
          {
            title: "Cart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/cart`,
          },
          {
            title: "Wishlist",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/wishlist`,
          },
          {
            title: "Checkout",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/checkout`,
          },
          {
            title: "Pricing",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/ecommerce/pricing`,
          },
        ],
      },
      {
        id: 6,
        title: "Letter Box",
        url: `${process.env.PUBLIC_URL}/applications/email/letter_box`,
        icon: "email",
        type: "link",
      },
      {
        id: 7,
        title: "Chats",
        icon: "chat",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Private Chat",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/chat/chat_private`,
          },
          {
            title: "Group chat",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/chat/chat_group`,
          },
        ],
      },
      {
        id: 8,
        title: "Users",
        icon: "user",
        type: "sub",
        bookmark: true,
        active: false,
        menu: [
          {
            title: "Users Profile",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/users/user_profile`,
          },
          {
            title: "Users Edit",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/users/edit_profile`,
          },
          {
            title: "Users Cards",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/users/user_cards`,
          },
        ],
      },
      {
        id: 9,
        title: "Bookmarks",
        url: `${process.env.PUBLIC_URL}/applications/bookmark`,
        bookmark: true,
        type: "link",
        icon: "bookmark",
      },
      {
        id: 10,
        title: "Contacts",
        icon: "contact",
        url: `${process.env.PUBLIC_URL}/applications/contacts`,
        type: "link",
      },
      {
        id: 11,
        title: "Tasks",
        url: `${process.env.PUBLIC_URL}/applications/task`,
        icon: "task",
        type: "link",
      },
      {
        id: 12,
        title: "Calendar",
        url: `${process.env.PUBLIC_URL}/applications/calendar_basic`,
        icon: "calendar",
        type: "link",
      },
      {
        id: 13,
        title: "Social App",
        url: `${process.env.PUBLIC_URL}/applications/social_app`,
        bookmark: true,
        icon: "social",
        type: "link",
      },
      {
        id: 14,
        title: "To-Do",
        url: `${process.env.PUBLIC_URL}/applications/to_do`,
        bookmark: true,
        icon: "to-do",
        type: "link",
      },
      {
        id: 15,
        title: "Search Result",
        url: `${process.env.PUBLIC_URL}/applications/search`,
        icon: "search",
        type: "link",
      },
    ],
  },
  {
    title: "- Forms & Table",
    menu: [
      {
        id: 16,
        title: "Forms",
        icon: "form",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Form Controls",
            type: "sub",
            menu: [
              {
                title: "Form Validation",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_controls/form_validation`,
              },
              {
                title: "Base Inputs",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_controls/base_input`,
              },
              {
                title: "Checkbox & Radio",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_controls/radio_checkbox_control`,
              },
              {
                title: "Input Groups",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_controls/input_group`,
              },
              {
                title: "Input Mask",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_controls/input_mask`,
              },
              {
                title: "Mega Options",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_controls/mega_options`,
              },
            ],
          },
          {
            title: "Form Widgets",
            type: "sub",
            menu: [
              {
                title: "Datepicker",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_widgets/datepicker`,
              },
              {
                title: "Touchspin",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_widgets/touchspin`,
              },
              {
                title: "Switch",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_widgets/switch`,
              },
              {
                title: "Typeahead",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_widgets/typeahead`,
              },
              {
                title: "Clipboard",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_widgets/clipboard`,
              },
            ],
          },
          {
            title: "Form Layout",
            type: "sub",
            menu: [
              {
                title: "Form Wizard 1",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_1`,
              },
              {
                title: "Form Wizard 2",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_layout/form_wizard_2`,
              },
              {
                title: "Two Factor",
                type: "link",
                url: `${process.env.PUBLIC_URL}/forms/form_layout/two_factor`,
              },
            ],
          },
        ],
      },
      {
        id: 17,
        title: "Tables",
        icon: "table",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Reactstrap Tables",
            type: "sub",
            menu: [
              {
                title: "Basic Tables",
                type: "link",
                url: `${process.env.PUBLIC_URL}/table/reactstrap_tables/basic_table`,
              },
              {
                title: "Table Components",
                type: "link",
                url: `${process.env.PUBLIC_URL}/table/reactstrap_tables/table_components`,
              },
            ],
          },
          {
            title: "Data Tables",
            type: "sub",
            menu: [
              {
                title: "Basic Init",
                type: "link",
                url: `${process.env.PUBLIC_URL}/table/data_tables/basic_init`,
              },
              {
                title: "Advance Init",
                type: "link",
                url: `${process.env.PUBLIC_URL}/table/data_tables/advance_init`,
              },
              {
                title: "API",
                type: "link",
                url: `${process.env.PUBLIC_URL}/table/data_tables/api`,
              },
              {
                title: "Data Sources",
                type: "link",
                url: `${process.env.PUBLIC_URL}/table/data_tables/data_sources`,
              },
            ],
          },
          {
            title: "Js Grid Table",
            type: "sub",
            url: `${process.env.PUBLIC_URL}/table/js_grid_tables`,
          },
        ],
      },
    ],
  },
  {
    title: "- Components",
    menu: [
      {
        id: 18,
        title: "Ui Kits",
        icon: "ui-kits",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Typography",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/typography`,
          },
          {
            title: "Avatars",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/avatars`,
          },
          {
            title: "Helper Classes",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/helper_classes`,
          },
          {
            title: "Grid",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/grid`,
          },
          {
            title: "Tag & pills",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/tag_pills`,
          },
          {
            title: "Progress",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/progress_bar`,
          },
          {
            title: "Modal",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/modal`,
          },
          {
            title: "Alert",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/alert`,
          },
          {
            title: "Popover",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/popover`,
          },
          {
            title: "Tooltip",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/tooltip`,
          },
          {
            title: "Dropdown",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/dropdown`,
          },
          {
            title: "Accordion",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/accordion`,
          },
          {
            title: "Tabs",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/tabs`,
          },
          {
            title: "Lists",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/ui_kits/lists`,
          },
        ],
      },
      {
        id: 19,
        title: "Bonus Ui",
        icon: "bonus-kit",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Scrollable",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/scrollable`,
          },
          {
            title: "Tree View",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/tree`,
          },
          {
            title: "Toasts",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/toasts`,
          },
          {
            title: "Rating",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/rating`,
          },
          {
            title: "Dropzone",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/dropzone`,
          },
          {
            title: "Tour",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/tour`,
          },
          {
            title: "SweetAlert2",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/sweet_alert_2`,
          },
          {
            title: "Owl Carousel",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/owl_carousel`,
          },
          {
            title: "Ribbons",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/ribbons`,
          },
          {
            title: "Pagination",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/pagination`,
          },
          {
            title: "Breadcrumb",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/breadcrumb`,
          },
          {
            title: "Range Slider",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/range_slider`,
          },
          {
            title: "Image Cropper",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/image_cropper`,
          },
          {
            title: "Basic Card",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/basic_card`,
          },
          {
            title: "Creative Card",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/creative_card`,
          },
          {
            title: "Timeline",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/bonus_ui/timeline`,
          },
        ],
      },
      {
        title: "Icons",
        icon: "icons",
        id: 20,
        type: "sub",
        active: false,
        menu: [
          {
            title: "Flag icon",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/icons/flag_icon`,
          },
          {
            title: "Fontawesome Icon",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/icons/font_awesome`,
          },
          {
            title: "Ico Icon",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/icons/ico_icon`,
          },
          {
            title: "Themify Icon",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/icons/themify_icon`,
          },
          {
            title: "Feather Icon",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/icons/feather_icon`,
          },
          {
            title: "Whether Icon",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/icons/whether_icon`,
          },
        ],
      },
      {
        id: 21,
        title: "Buttons",
        url: `${process.env.PUBLIC_URL}/components/buttons`,
        icon: "button",
        type: "link",
      },
      {
        title: "Charts",
        icon: "charts",
        type: "sub",
        id: 22,
        active: false,
        menu: [
          {
            title: "Apex Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/charts/chart_apex`,
          },
          {
            title: "Google Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/charts/chart_google`,
          },
          {
            title: "Chartjs Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/charts/chartjs`,
          },
        ],
      },
    ],
  },
  {
    title: "- Pages",
    menu: [
      {
        id: 23,
        title: "Sample Page",
        url: `${process.env.PUBLIC_URL}/pages/sample_page`,
        icon: "sample-page",
        type: "link",
      },
      {
        id: 24,
        title: "Others",
        icon: "others",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Error Page",
            type: "sub",
            menu: [
              {
                title: "Error 400",
                type: "link",
                url: `${process.env.PUBLIC_URL}/others/error_page_400`,
              },
              {
                title: "Error 401",
                type: "link",
                url: `${process.env.PUBLIC_URL}/others/error_page_401`,
              },
              {
                title: "Error 403",
                type: "link",
                url: `${process.env.PUBLIC_URL}/others/error_page_403`,
              },
              {
                title: "Error 404",
                type: "link",
                url: `${process.env.PUBLIC_URL}/others/error_page_404`,
              },
              {
                title: "Error 500",
                type: "link",
                url: `${process.env.PUBLIC_URL}/others/error_page_500`,
              },
              {
                title: "Error 503",
                type: "link",
                url: `${process.env.PUBLIC_URL}/others/error_page_503`,
              },
            ],
          },
          {
            title: "Authentication",
            type: "sub",
            menu: [
              {
                title: "Login Simple",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/login`,
              },
              {
                title: "Visual Login",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/login_bg_img`,
              },
              {
                title: "Visual Login 2",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/login_bg_img2`,
              },
              {
                title: "Validate Login",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/login_bs_validation`,
              },
              {
                title: "Tooltip Login",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/login_bs_tooltip`,
              },
              {
                title: "Alert Login",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/login_sa_validation`,
              },
              {
                title: "Register",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/sign_up`,
              },
              {
                title: "Register Image",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/sign_up_one`,
              },
              {
                title: "Visual Reg 2",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/sign_up_two`,
              },
              {
                title: "Reg Wizard",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/sign_up_wizard`,
              },
              {
                title: "Unlock User",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/unlock`,
              },
              {
                title: "Pwd Forget",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/forget_password`,
              },
              {
                title: "Pwd Reset",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/reset_password`,
              },
              {
                title: "Maintenance",
                type: "link",
                url: `${process.env.PUBLIC_URL}/auth/maintenance`,
              },
            ],
          },
          {
            title: "Coming Soon",
            type: "sub",
            menu: [
              {
                title: "Coming Simple",
                type: "link",
                url: `${process.env.PUBLIC_URL}/coming_soon/coming_simple`,
              },
              {
                title: "Coming Bg Vid",
                type: "link",
                url: `${process.env.PUBLIC_URL}/coming_soon/coming_bg_video`,
              },
              {
                title: "Coming Bg Img",
                type: "link",
                url: `${process.env.PUBLIC_URL}/coming_soon/coming_bg_img`,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "- Settings Section",
    menu: [
      {
        id: 25,
        title: "Gallery",
        icon: "gallery",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Gallery Grid",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery`,
          },
          {
            title: "Gallery Grid Desc",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/gallery/grid_gallery_description`,
          },
          {
            title: "Masonry Gallery",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry_gallery`,
          },
          {
            title: "Masonry With Desc",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/gallery/masonry_gallery_description`,
          },
          {
            title: "Hover Effects",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/gallery/gallery_hover`,
          },
        ],
      },
      {
        id: 26,
        title: "Blog",
        icon: "blog",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Blog Details",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/blog/blog_detail`,
          },
          {
            title: "Blog Single",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/blog/blog_single`,
          },
          {
            title: "Add Post",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/blog/add_post`,
          },
        ],
      },
      {
        id: 27,
        title: "FAQ",
        type: "link",
        icon: "faq",
        url: `${process.env.PUBLIC_URL}/miscellaneous/faq`,
      },
      {
        id: 28,
        title: "Job Search",
        icon: "job-search",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Cards view",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_cards_view`,
          },
          {
            title: "List View",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_list_view`,
          },
          {
            title: "Job Details",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_details`,
          },
          {
            title: "Apply",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/job_search/job_apply`,
          },
        ],
      },
      {
        id: 29,
        title: "Learning",
        icon: "learning",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Learning List",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/learning/learning_list_view`,
          },
          {
            title: "Detailed Course",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/learning/course_details`,
          },
        ],
      },
      {
        id: 30,
        title: "Maps",
        icon: "maps",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Google Maps",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/maps/google_map`,
          },
          {
            title: "Leaflet Maps",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/maps/leaflet_map`,
          },
        ],
      },
      {
        id: 31,
        title: "Editors",
        icon: "editors",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Quill Editor",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/editors/quill_editor`,
          },
          {
            title: "ACE Code Editor",
            type: "link",
            url: `${process.env.PUBLIC_URL}/miscellaneous/editors/ace_code_editor`,
          },
        ],
      },
      {
        id: 32,
        title: "Knowledgebase",
        icon: "knowledgebase",
        type: "link",
        active: false,
        url: `${process.env.PUBLIC_URL}/miscellaneous/knowledgebase`,
        resource: "create_plan",
      },
      {
        id: 33,
        title: "Support Ticket",
        icon: "support-tickets",
        type: "link",
        active: false,
        url: `${process.env.PUBLIC_URL}/miscellaneous/support_ticket`,
      },
      {
        id: 34,
        title: "Setting",
        icon: "user",
        type: "sub",
        bookmark: true,
        active: false,
        menu: [
          {
            title: "Users",
            type: "link",
            url: `${process.env.PUBLIC_URL}/applications/users/user_profile`,
          },
          {
            title: "Users Edit",
            type: "link",
            url: `${process.env.PUBLIC_URL}/settings/`,
          },
          // {
          //     title: 'Users Cards',
          //     type: 'link',
          //     url: `${process.env.PUBLIC_URL}/applications/users/user_cards`,
          // },
        ],
      },
      {
        id: 35,
        title: "Settings",
        icon: "user",
        type: "sub",
        // bookmark: true,
        active: false,
        menu: [
          // {
          //     title: 'Users',
          //     type: 'link',
          //     url: `${process.env.PUBLIC_URL}/applications/users/user_profile`,
          // },
          // {
          //     title: 'Users Edit',
          //     type: 'link',
          //     url: `${process.env.PUBLIC_URL}/settings/`,
          // },
          // {
          //     title: 'Users Cards',
          //     type: 'link',
          //     url: `${process.env.PUBLIC_URL}/applications/users/user_cards`,
          // },

          {
            title: "Company Settings",
            type: "sub",
            menu: [
              {
                title: "Onboard New Company",
                type: "link",
                url: `${process.env.PUBLIC_URL}/settings/company/register-company`,
                resource: "admin",
              },
              {
                title: "List Companies",
                type: "link",
                url: `${process.env.PUBLIC_URL}/settings/company/list-register-company`,
                resource: "admin",
              },
              {
                title: "List Trials",
                type: "link",
                url: `${process.env.PUBLIC_URL}/settings/company/trail-request`,
                resource: "admin",
              },
            ],
          },

          {
            title: "Plans and Pricing",
            type: "sub",
            menu: [
              {
                title: "All plans and pricings",
                type: "link",
                url: `${process.env.PUBLIC_URL}/settings/plans-and-pricing/`,
                resource: "admin",
              },
              {
                title: "Create plans and pricings",
                type: "link",
                url: `${process.env.PUBLIC_URL}/settings/plans-and-pricing/create-plans`,
                resource: "admin",
              },
            ],
          },
          {
            title: "Countries",
            type: "link",
            url: `${process.env.PUBLIC_URL}/settings/countries/`,
            resource: "admin",
          },
        ],
      },
    ],
  },

  {
    title: "Log Sections",

    menu: [
      {
        icon: "knowledgebase",
        title: "Error Log",
        type: "link",
        url: `${process.env.PUBLIC_URL}/settings/admin-error-log`,
        resource: "admin",
      },
    ],
  },

  {
    title: "Paper",
    apps: "Paper App",
    menu: [
      {
        id: 1,
        title: "Paper",
        icon: "home",
        badge: true,
        badgeName: "3",
        badgeColor: "light-primary",
        type: "sub",
        active: false,
        resource: "trail_company",
        menu: [
          {
            title: "Holidays",
            type: "link",
            url: `${process.env.PUBLIC_URL}/paper/holidays`,
          },
          {
            title: "Ecommerce",
            type: "link",
            url: `${process.env.PUBLIC_URL}/dashboard/ecommerce`,

            // resource: "admin",
          },
          {
            title: "Project",
            type: "link",
            url: `${process.env.PUBLIC_URL}/dashboard/project`,
          },
        ],
      },
      {
        id: 2,
        title: "Widgets",
        icon: "widget",
        type: "sub",
        active: false,

        menu: [
          {
            title: "General",
            type: "link",
            url: `${process.env.PUBLIC_URL}/widgets/general_widget`,
          },
          {
            title: "Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/widgets/chart_widget`,
          },
        ],
      },
    ],
  },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  {
    title: "User Management",
    menu: [
      {
        id: 21,
        title: "Users",
        url: `${process.env.PUBLIC_URL}/company/user-management/list`,
        icon: "user",
        type: "link",
        resource: "user_management_read",
      },
      {
        id: 21,
        title: "Create New User",
        url: `${process.env.PUBLIC_URL}/company/user-management`,
        icon: "user",
        type: "link",
        resource: "user_management_create",
      },
      {
        id: 21,
        title: "Groups",
        url: `${process.env.PUBLIC_URL}/company/user-management`,
        icon: "button",
        type: "link",
        resource: "group_management",
      },

      {
        title: "Charts",
        icon: "charts",
        type: "sub",
        id: 22,
        active: false,
        menu: [
          {
            title: "Apex Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/charts/chart_apex`,
          },
          {
            title: "Google Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/charts/chart_google`,
          },
          {
            title: "Chartjs Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/charts/chartjs`,
          },
        ],
      },
    ],
  },

  {
    title: "Group  Management",
    menu: [
      {
        id: 21,
        title: "Groups",
        url: `${process.env.PUBLIC_URL}/company/group-management/list`,
        icon: "user",
        type: "link",
        resource: "group_management_read",
      },
      {
        id: 21,
        title: "Create Groups",
        url: `${process.env.PUBLIC_URL}/company/group-management/create`,
        icon: "button",
        type: "link",
        resource: "group_management_create",
      },

      {
        title: "Charts",
        icon: "charts",
        type: "sub",
        id: 22,
        active: false,
        menu: [
          {
            title: "Apex Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/charts/chart_apex`,
          },
          {
            title: "Google Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/charts/chart_google`,
          },
          {
            title: "Chartjs Chart",
            type: "link",
            url: `${process.env.PUBLIC_URL}/components/charts/chartjs`,
          },
        ],
      },
    ],
  },
  {
    title: "-Home",
    apps: "trading",
    menu: [
      {
        id: 361,
        title: "Dashboard",
        icon: "widget", // ✅ Feather icon that looks like dashboard tiles
        type: "sub",
        active: false,
        menu: [
          {
            title: "Portfolio",
            type: "link",
            url: `${process.env.PUBLIC_URL}/dashboard/default`,
            resource: "paper_trading_read",
          },
          {
            title: "P&L Summary",
            type: "link",
            url: `${process.env.PUBLIC_URL}/dashboard/default`,
            resource: "paper_trading_read",
          },
          {
            title: "Risk Heatmap",
            type: "link",
            url: `${process.env.PUBLIC_URL}/dashboard/default`,
            resource: "paper_trading_read",
          },
          {
            title: "Market Prices",
            type: "link",
            url: `${process.env.PUBLIC_URL}/dashboard/default`,
            resource: "paper_trading_read",
          },
        ],
      },
    ],
  },
  {
    title: "- Trading",
    apps: "trading",
    menu: [
      {
        id: 361,
        title: "Trading", // ✅ main title changed
        icon: "project", // feather icon for main menu item
        type: "sub",
        active: false,
        menu: [
          {
            // ---------- Paper ----------
            title: "Paper",
            type: "sub", // nested sub menu
            menu: [
              {
                title: "Trade Capture(Manual)",
                type: "link",
                url: `${process.env.PUBLIC_URL}/paper/trade-capture/manual`,
                resource: "paper_trading_read",
              },
              {
                title: "Exchange Trades",
                type: "link",
                url: `${process.env.PUBLIC_URL}/paper/trade-capture/api/ice-exchange`,
                resource: "paper_trading_read",
              },
              {
                title: "Deal Blotter",
                type: "sub",
                menu: [
                  {
                    title: "Organization Trades",
                    type: "link",
                    url: `${process.env.PUBLIC_URL}/paper/deal-bottler/organization-trades`,
                    resource: "paper_trading_read",
                  },
                  {
                    title: "Counterparty Trades",
                    type: "link",
                    url: `${process.env.PUBLIC_URL}/paper/deal-bottler/counterparty-trades`,
                    resource: "paper_position_read",
                  },
                ],
                url: "",
              },
              {
                title: "Trade Confirmation",
                type: "link",
                url: `${process.env.PUBLIC_URL}/trading/trade-reconciliation`,
                resource: "paper_trading_read",
              },
            ],
          },
          {
            // ---------- Paper ----------
            title: "Physical",
            type: "sub", // nested sub menu
            menu: [
              {
                title: "Physical Trade",
                type: "link",
                url: `${process.env.PUBLIC_URL}/trading/trade-capture`,
                resource: "paper_trading_read",
              },
            ],
          },
          // {
          //   title: "Cost Booking",
          //   type: "link",
          //   url: `${process.env.PUBLIC_URL}/paper/cost-booking`,
          //   resource: "paper_trading_read",
          // },
        ],
      },
    ],
  },
  {
    title: "-Position & Risk",
    apps: "trading",
    menu: [
      {
        id: 361,
        title: "Position & Risk",
        icon: "charts", // ✅ Feather icon that looks like dashboard tiles
        type: "sub",
        active: false,
        menu: [
          {
            title: "Position",
            type: "link",
            url: `${process.env.PUBLIC_URL}/trading/paper-position`,
            resource: "paper_position_read",
          },
          {
            title: "Daily Exposure",
            type: "link",
            url: `${process.env.PUBLIC_URL}/trading/paper-exposure`,
            resource: "paper_exposure_read",
          },
          {
            title: "P&L",
            type: "sub",
            menu: [
              {
                title: "P&L View-1",
                type: "link",
                url: `${process.env.PUBLIC_URL}/reports/pnl-summary/view-1`,
                resource: "paper_trading_read",
              },
              {
                title: "P&L View-2",
                type: "link",
                url: `${process.env.PUBLIC_URL}/reports/pnl-summary/view-2`,
                resource: "paper_position_read",
              },
              {
                title: "P&L View-3",
                type: "link",
                url: `${process.env.PUBLIC_URL}/reports/pnl-summary/view-3`,
                resource: "paper_position_read",
              },
            ],
            url: "",
          },
          {
            title: "Initial Margin",
            type: "link",
            url: `${process.env.PUBLIC_URL}/reports/initial-margin`,
            resource: "paper_position_read",
          },
          {
            title: "Initial Margin Summary",
            type: "link",
            url: `${process.env.PUBLIC_URL}/reports/initial-margin-summary`,
            resource: "paper_position_read",
          },
        ],
      },
    ],
  },
  {
    title: "-Price Data",
    apps: "trading",
    menu: [
      {
        id: 361,
        title: "Price Data",
        icon: "animation", // ✅ Feather icon that looks like dashboard tiles
        type: "sub",
        active: false,
        menu: [
          {
            title: "Settlement Prices",
            type: "link",
            url: `${process.env.PUBLIC_URL}/trading/settlement-price`,
            resource: "settlement_price_read",
          },
        ],
      },
    ],
  },
  //   {
  //   title: "",
  //   apps: "trading",
  //   menu: [
  //     {
  //       id: 361,
  //       title: "System Admin",
  //       icon: "knowledgebase", // ✅ Feather icon that looks like dashboard tiles
  //       type: "sub",
  //       active: false,
  //       menu: [
  //         {
  //           title: "Settings",
  //           type: "link",
  //           url: `${process.env.PUBLIC_URL}/company/user-management/list`,
  //           resource: "paper_trading_read",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    title: "-Paper Trading Settings",
    menu: [
      {
        id: 362,
        title: "Reference Data",
        icon: "faq",
        type: "sub",

        active: false,
        menu: [
          {
            title: "Broker",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/broker`,
            resource: "broker_management_read",
          },
          {
            title: "Clearer",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/clearer`,
            resource: "clearer_management_read",
          },
          {
            title: "Books",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/book`,
            resource: "book_management_read",
          },
          {
            title: "Strategy",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/strategy`,
            resource: "strategy_management_read",
          },
          {
            title: "Derivative",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/derivative`,
            resource: "derivative_management_read",
          },
          {
            title: "Holiday",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/holiday`,
            resource: "holiday_management_read",
          },

          {
            title: "Contract Type",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/contract-type`,
            resource: "type_management_read",
          },
          {
            title: "Units",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/units`,
            resource: "unit_management_read",
          },
          {
            title: "Contract",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/contract-form`,
            resource: "contract_read",
          },
          {
            title: "Counterparty Companies",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/counterparty-companies`,
            resource: "counter_party_management_read",
          },

          {
            title: "Clearer Rates",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/clearer-rates`,
            resource: "clearer_rates_read",
          },

          {
            title: "Brokerage",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/brokerage`,
            resource: "brokerage_read",
          },
          {
            title: "Exchange Settings",
            type: "sub",
            menu: [
              {
                title: "Connectivity Console",
                type: "link",
                url: `${process.env.PUBLIC_URL}/data-table/exchange-settings/connectivity-management`,
                resource: "api_settings_read",
              },
              {
                title: "API Settings",
                type: "link",
                url: `${process.env.PUBLIC_URL}/data-table/api-setting`,
                resource: "api_settings_read",
              },
              {
                title: "Broker Mapping",
                type: "link",
                url: `${process.env.PUBLIC_URL}/data-table/api-broker-setting`,
                resource: "api_settings_read",
              },
              {
                title: "Trader Mapping",
                type: "link",
                url: `${process.env.PUBLIC_URL}/data-table/trader-mapping`,
                resource: "api_settings_read",
              },
              // {
              //   title: "Company Name Mapping",
              //   type: "link",
              //   url: `${process.env.PUBLIC_URL}/data-table/company-name-mapping`,
              //   resource: "api_settings_read",
              // },

            ],
          },
          {
            title: "Clearing account",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/Clearing-account`,
            resource: "clearing_account_read",
          },
          {
            title: "File Uploads",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/file-uploads`,
            resource: "file_uploads_read",
          },
          {
            title: "Futures LTD",
            type: "link",
            url: `${process.env.PUBLIC_URL}/futuresltd`,
            resource: "api_settings_read",
          },
          {
            title: "Security Definitions",
            type: "link",
            url: `${process.env.PUBLIC_URL}/settings/security-definitions`,
            resource: "api_settings_read",
          },
          {
            title: "Exchange&Clearing",
            type: "link",
            url: `${process.env.PUBLIC_URL}/settings/exchange-clearings`,
            resource: "api_settings_read",
          },
          {
            title: "File Upload",
            type: "link",
            url: `${process.env.PUBLIC_URL}/Settings/file-uploads`,
            resource: "api_settings_read",
          },
          {
            title: "JV",
            type: "sub",
            menu: [
              {
                title: "Customer Markup Matrix",
                type: "link",
                url: `${process.env.PUBLIC_URL}/Settings/customer-markup-matrix`,
                resource: "api_settings_read",
              },
              {
                title: "Profit Share % Split",
                type: "link",
                url: `${process.env.PUBLIC_URL}/data-table/profitshare-by-book`,
                resource: "book_management_read",
              },

            ],
          },
          // {
          //   title: "Cost Object",
          //   type: "sub",
          //   menu: [
          {
            title: "Cost Type",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/cost-type`,
            resource: "api_settings_read",
          },
          // {
          //   title: "Cost Status",
          //   type: "link",
          //   url: `${process.env.PUBLIC_URL}/data-table/cost-status`,
          //   resource: "api_settings_read",
          // },
          //   ]
          // }

          // {
          //     title: 'Charts',
          //     icon: 'charts',
          //     type: 'sub',
          //     id: 22,
          //     active: false,
          //     menu: [
          //         {
          //             title: 'Apex Chart',
          //             type: "link",
          //             url: `${process.env.PUBLIC_URL}/components/charts/chart_apex`,

          //         },
          //         {
          //             title: 'Google Chart',
          //             type: "link",
          //             url: `${process.env.PUBLIC_URL}/components/charts/chart_google`,
          //         },
          //         {
          //             title: 'Chartjs Chart',
          //             type: "link",
          //             url: `${process.env.PUBLIC_URL}/components/charts/chartjs`,
          //         },
          //     ],
          // },
        ],
      },
    ],
  },
  // {
  //   title: "-Reporting & Analytics",
  //   apps: "trading",
  //   menu: [
  //     {
  //       id: 361,
  //       title: "Reporting & Analytics",
  //       icon: "starter-kit", // ✅ Feather icon that looks like dashboard tiles
  //       type: "sub",
  //       active: false,
  //       menu: [
  //         {
  //           title: "Brokerage Report",
  //           type: "link",
  //           url: `${process.env.PUBLIC_URL}/reports/brokerage`,
  //           resource: "paper_trading_read",
  //         },
  //         {
  //           title: "Clearer Rate Report",
  //           type: "link",
  //           url: `${process.env.PUBLIC_URL}/reports/clearer-report`,
  //           resource: "paper_trading_read",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    title: "Reconciliation",
    apps: "trading",
    menu: [
      {
        id: 361,
        title: "Reconciliation",
        icon: "internationalization", // ✅ Feather icon that looks like dashboard tiles
        type: "sub",
        active: false,
        menu: [
          {
            title: "Broker Reconciliation",
            type: "link",
            url: `${process.env.PUBLIC_URL}/data-table/reconciliation-automation`,
            resource: "broker_management_read",
          },
          {
            title: "Mappings",
            type: "sub",
            menu: [
              {
                title: "Customer Mapping",
                type: "link",
                url: `${process.env.PUBLIC_URL}/data-table/customer-mapping`,
                resource: "broker_management_read",
              },
              {
                title: "Contract Mapping",
                type: "link",
                url: `${process.env.PUBLIC_URL}/data-table/contract-mapping`,
                resource: "broker_management_read",
              },

            ],
          },
        ],
      },
    ],
  },
  {
    title: "Costs",
    apps: "trading",
    menu: [
      {
        id: 361,
        title: "Costs",
        icon: "form", 
        type: "sub",
        active: false,
        menu: [
          {
            title: "Cost Management",
            type: "link",
            url: `${process.env.PUBLIC_URL}/paper/cost-management`,
            resource: "broker_management_read",
          },
          // {
          //   title: "Cashflow ",
          //   type: "link",
          //   url: `${process.env.PUBLIC_URL}/paper/cashflow`,
          //   resource: "paper_trading_read",
          // },
        ],
      },
    ],
  },
  {
    title: "-System Admin",
    apps: "trading",
    menu: [
      {
        id: 361,
        title: "System Admin",
        icon: "knowledgebase", // ✅ Feather icon that looks like dashboard tiles
        type: "sub",
        active: false,
        menu: [
          {
            title: "Settings",
            type: "link",
            url: `${process.env.PUBLIC_URL}/company/user-management/list`,
            resource: "paper_trading_read",
          },
        ],
      },
    ],
  },
  {
    title: "Operation Control Center",
    apps: "trading",
    menu: [
      {
        id: 361,
        title: "Operation Control Center",
        icon: "knowledgebase", // ✅ Feather icon that looks like dashboard tiles
        type: "sub",
        active: false,
        menu: [
          {
            title: "P&L Operations",
            type: "link",
            url: `${process.env.PUBLIC_URL}/operations-control-center/pnl-operations`,
            resource: "paper_trading_read",
          },
        ],
      },
    ],
  },
  {
    title: "-Log",
    apps: "trading",
    menu: [
      {
        id: 361,
        title: "Price Update Manager",
        icon: "project",
        type: "sub",
        active: false,
        menu: [
          {
            title: "Price Update Manager",
            type: "link",
            url: `${process.env.PUBLIC_URL}/log/price-update-manager`,
            resource: "paper_trading_read",
          },
        ],
      },
    ],
  },
  // {
  //   title: "Paper Trading",
  //   menu: [
  //     {
  //       id: 363,
  //       title: "Paper Trading",
  //       icon: "user",
  //       type: "sub",

  //       active: false,
  //       menu: [
  //         {
  //           title: "Paper Trading",
  //           type: "link",
  //           url: `${process.env.PUBLIC_URL}/trading/paper-trading`,
  //           resource: "paper_trading_read",
  //         },
  //         {
  //           title: "Paper Position",
  //           type: "link",
  //           url: `${process.env.PUBLIC_URL}/trading/paper-position`,
  //           resource: "paper_position_read",
  //         },
  //         {
  //           title: "Paper Exposure",
  //           type: "link",
  //           url: `${process.env.PUBLIC_URL}/trading/paper-exposure`,
  //           resource: "paper_exposure_read",
  //         },
  //         {
  //           title: "Settlement Price",
  //           type: "link",
  //           url: `${process.env.PUBLIC_URL}/trading/settlement-price`,
  //           resource: "settlement_price_read",
  //         },
  //         {
  //           title: "Paper Trading History",
  //           type: "link",
  //           url: `${process.env.PUBLIC_URL}/trading/paper-trading-history`,
  //           resource: "paper_trading_history_read",
  //         },

  //         {
  //           title: "Report",
  //           type: "sub",
  //           menu: [
  //             {
  //               title: "Brokerage",
  //               type: "link",
  //               url: `${process.env.PUBLIC_URL}/reports/brokerage`,
  //               resource: "paper_trading_read",
  //             },
  //             {
  //               title: "P&L Summary",
  //               type: "link",
  //               url: `${process.env.PUBLIC_URL}/reports/pnl-summary`,
  //               resource: "paper_position_read",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },

  // {
  //   title: "Paper Trading Settings",

  //   menu: [
  //     {
  //       title: "Broker",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/broker`,
  //       resource: "broker_management_read",
  //     },
  //     {
  //       title: "Clearer",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/clearer`,
  //       resource: "clearer_management_read",
  //     },
  //     {
  //       title: "Books",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/book`,
  //       resource: "book_management_read",
  //     },
  //     {
  //       title: "Strategy",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/strategy`,
  //       resource: "strategy_management_read",
  //     },
  //     {
  //       title: "Derivative",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/derivative`,
  //       resource: "derivative_management_read",
  //     },
  //     {
  //       title: "Holiday",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/holiday`,
  //       resource: "holiday_management_read",
  //     },

  //     {
  //       title: "Contract Type",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/contract-type`,
  //       resource: "type_management_read",
  //     },
  //     {
  //       title: "Units",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/units`,
  //       resource: "unit_management_read",
  //     },
  //     {
  //       title: "Contract",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/contract-form`,
  //       resource: "contract_read",
  //     },
  //     {
  //       title: "Counterparty Companies",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/counterparty-companies`,
  //       resource: "counter_party_management_read",
  //     },

  //     {
  //       title: "Clearer Rates",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/clearer-rates`,
  //       resource: "clearer_rates_read",
  //     },

  //     {
  //       title: "Brokerage",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/brokerage`,
  //       resource: "brokerage_read",
  //     },
  //     {
  //       title: "API Settings",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/api-setting`,
  //       resource: "api_settings_read",
  //     },

  //     {
  //       title: "Clearing account",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/Clearing-account`,
  //       resource: "clearing_account_read",
  //     },
  //     {
  //       title: "File Uploads",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/data-table/file-uploads`,
  //       resource: "file_uploads_read",
  //     },
  //     {
  //       title: "Future LTD",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/futuresltd`,
  //       resource: "api_settings_read",
  //     },

  //     // {
  //     //     title: 'Charts',
  //     //     icon: 'charts',
  //     //     type: 'sub',
  //     //     id: 22,
  //     //     active: false,
  //     //     menu: [
  //     //         {
  //     //             title: 'Apex Chart',
  //     //             type: "link",
  //     //             url: `${process.env.PUBLIC_URL}/components/charts/chart_apex`,

  //     //         },
  //     //         {
  //     //             title: 'Google Chart',
  //     //             type: "link",
  //     //             url: `${process.env.PUBLIC_URL}/components/charts/chart_google`,
  //     //         },
  //     //         {
  //     //             title: 'Chartjs Chart',
  //     //             type: "link",
  //     //             url: `${process.env.PUBLIC_URL}/components/charts/chartjs`,
  //     //         },
  //     //     ],
  //     // },
  //   ],
  // },

  // {
  //   title: "Paper Trading ",
  //   menu: [
  //     {
  //       title: "Paper Trading",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/trading/paper-trading`,
  //       resource: "paper_trading_read",
  //     },
  //     {
  //       title: "Paper Position",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/trading/paper-position`,
  //       resource: "paper_position_read",
  //     },
  //     {
  //       title: "Paper Exposure",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/trading/paper-exposure`,
  //       resource: "paper_exposure_read",
  //     },
  //     {
  //       title: "Settlement Price",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/trading/settlement-price`,
  //       resource: "settlement_price_read",
  //     },
  //     {
  //       title: "Paper Trading History",
  //       type: "link",
  //       url: `${process.env.PUBLIC_URL}/trading/paper-trading-history`,
  //       resource: "paper_trading_history_read",
  //     },
  //   ],
  // },

  {
    title: "Accounting",
    menu: [
      {
        title: "Sales Invoice",
        type: "link",
        url: `${process.env.PUBLIC_URL}/data-table/broker`,
        resource: "sales_invoice_read",
      },
      {
        title: "Journal Entry",
        type: "link",
        url: `${process.env.PUBLIC_URL}/data-table/clearer`,
        resource: "journal_entry_read",
      },
      {
        title: "Payment Entry",
        type: "link",
        url: `${process.env.PUBLIC_URL}/data-table/book`,
        resource: "payment_entry_read",
      },
      {
        title: "General Ledger",
        type: "link",
        url: `${process.env.PUBLIC_URL}/data-table/strategy`,
        resource: "general_ledger_read",
      },
      {
        title: "Accounts Receivable",
        type: "link",
        url: `${process.env.PUBLIC_URL}/data-table/derivative`,
        resource: "accounts_receivable_read",
      },
      {
        title: "Payments",
        type: "link",
        url: `${process.env.PUBLIC_URL}/data-table/holiday`,
        resource: "payments_read",
      },
      {
        title: "bank_account",
        type: "link",
        url: `${process.env.PUBLIC_URL}/data-table/type`,
        resource: "bank_account_read",
      },
      {
        title: "Bank Reconciliation Statement",
        type: "link",
        url: `${process.env.PUBLIC_URL}/data-table/unit`,
        resource: "bank_reconciliation_statement_read",
      },
      {
        title: "Tax Masters",
        type: "link",
        url: `${process.env.PUBLIC_URL}/data-table/counterparty-companies`,
        resource: "tax_masters_read",
      },

      // {
      //     title: 'Charts',
      //     icon: 'charts',
      //     type: 'sub',
      //     id: 22,
      //     active: false,
      //     menu: [
      //         {
      //             title: 'Apex Chart',
      //             type: "link",
      //             url: `${process.env.PUBLIC_URL}/components/charts/chart_apex`,

      //         },
      //         {
      //             title: 'Google Chart',
      //             type: "link",
      //             url: `${process.env.PUBLIC_URL}/components/charts/chart_google`,
      //         },
      //         {
      //             title: 'Chartjs Chart',
      //             type: "link",
      //             url: `${process.env.PUBLIC_URL}/components/charts/chartjs`,
      //         },
      //     ],
      // },
    ],
  },

  {
    title: "API Trades",
    menu: [
      {
        title: "ICEAPI Trades",
        type: "link",
        url: `${process.env.PUBLIC_URL}/APITrades/ICEAPI-Trades`,
      },
    ],
  },
];

export default menuList;

function filterMenuItems(data: any[], resourceList: string[]): any[] {
  function traverse(obj: any): any | null {
    if (typeof obj === "object" && obj !== null) {
      let newObj = { ...obj };

      if (newObj.menu && Array.isArray(newObj.menu)) {
        let filteredMenu: any[] = [];

        for (let item of newObj.menu) {
          let processedItem = traverse(item);

          if (
            (item.resource && resourceList.includes(item.resource)) ||
            (processedItem &&
              processedItem.menu &&
              processedItem.menu.length > 0)
          ) {
            filteredMenu.push(processedItem ?? item); // Use processedItem if available, otherwise original item
          }
        }

        newObj.menu = filteredMenu.length > 0 ? filteredMenu : undefined;
      }

      // Ensure items without a valid submenu and no matching resource are removed
      if (
        newObj.menu !== undefined ||
        (newObj.resource && resourceList.includes(newObj.resource))
      ) {
        return newObj;
      }

      return null;
    }
    return null;
  }

  return data.map(traverse).filter(Boolean);
}

// let resourceList:any= []

// const getResource = async()=>{
//     try {
//         const response = await axiosInstance.get(`${backendbaseUrl}/plans/list/`)
//         if (response.status === 200) {
//             const resourceList = response?.data?.results?.map((c: any) => ({
//                 value: c.id,
//                 name: c.name,
//                 max_users: c.max_users
//             }))

//         }

//     }

//     catch (error: any) {
//         if (error.response) {
//             if (error.response.status === 401) {
//                 toast.error("Unauthorized");
//             } else {
//                 toast.error(error.response.data.message || "An unknown error occurred");
//             }
//         } else {
//             toast.error("Network error or server is down");
//         }
//     }
// }

let resourceList: string[] = [];
try {
  const decryptedData: any = decryptData(localStorage.getItem("resourceList"));
  console.log(decryptedData, "encryptedData");
  resourceList = decryptedData;
  console.log(decryptedData);
} catch (error) {
  console.error("Error decrypting or parsing resourceList:", error);
  resourceList = []; // Default to empty array on error
}

menuList = filterMenuItems(menuList, resourceList);
console.log(menuList, "newmenulist");

export { menuList, filterMenuItems };
